export default function getjQuery() {
  if (window.jQuery) {
    return window.jQuery;
  }

  return null;
}
